import React from "react";
import { Form, Input, Button, Row, Col, Alert } from "antd";

const BecomeInstructor = () => {
    const onFinish = (values) => {
        console.log("Form values:", values);
        // Simule une réponse après soumission
        alert("Votre demande a été envoyée avec succès !");
    };

    return (
        <div style={{ backgroundColor: "#F7E9D8", minHeight: "100vh", padding: "40px" }}>
            <Row gutter={[16, 16]} justify="center" align="middle">
                {/* Section Image */}
                <Col xs={24} sm={24} md={12}>
                    <div style={{ textAlign: "center" }}>
                        <img
                            src="/images/become-a-instructor.png"
                            alt="Devenir Formateur"
                            style={{ width: "90%", maxWidth: "400px" }}
                        />
                    </div>
                </Col>

                {/* Section Formulaire */}
                <Col xs={24} sm={24} md={12}>
                    <div
                        style={{
                            backgroundColor: "#95D5B2",
                            padding: "30px",
                            borderRadius: "10px",
                            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                        }}
                    >
                        {/* <Alert
                            message="Une demande a déjà été envoyée, veuillez patienter."
                            type="error"
                            showIcon
                            style={{ marginBottom: "20px" }}
                        /> */}
                        <h2 style={{ color: "white", textAlign: "center", marginBottom: "20px" }}>
                            Inscrivez-vous pour devenir formateur
                        </h2>
                        <p style={{ color: "white", textAlign: "center", marginBottom: "20px" }}>
                            Votre adresse e-mail ne sera pas publiée. Tous les champs sont obligatoires.
                        </p>
                        <Form
                            name="instructorForm"
                            layout="vertical"
                            onFinish={onFinish}
                            style={{ color: "white" }}
                        >
                            <Form.Item
                                label="Nom Complet"
                                name="name"
                                rules={[{ required: true, message: "Veuillez entrer votre nom complet !" }]}
                            >
                                <Input placeholder="Instructor User" />
                            </Form.Item>

                            <Form.Item
                                label="Email"
                                name="email"
                                rules={[
                                    { required: true, message: "Veuillez entrer votre email !" },
                                    { type: "email", message: "Veuillez entrer un email valide !" },
                                ]}
                            >
                                <Input placeholder="instructor@elearniv.com" />
                            </Form.Item>

                            <Form.Item
                                label="Téléphone"
                                name="phone"
                                rules={[{ required: true, message: "Veuillez entrer votre numéro de téléphone !" }]}
                            >
                                <Input placeholder="+212XXXXXXXXX" />
                            </Form.Item>

                            <Form.Item
                                label="Sujet"
                                name="subject"
                                rules={[{ required: true, message: "Veuillez entrer un sujet !" }]}
                            >
                                <Input placeholder="Sujet de votre demande" />
                            </Form.Item>

                            <Form.Item
                                label="Message"
                                name="message"
                                rules={[{ required: true, message: "Veuillez entrer un message !" }]}
                            >
                                <Input.TextArea placeholder="Votre message..." rows={4} />
                            </Form.Item>

                            <Form.Item>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    block
                                    style={{
                                        backgroundColor: "#2D6A4F",
                                        color: "white",
                                        borderColor: "#2D6A4F",
                                        fontSize: "16px",
                                    }}
                                >
                                    Envoyer la demande
                                </Button>
                            </Form.Item>
                        </Form>
                    </div>
                </Col>
            </Row>
        </div>
    );
};

export default BecomeInstructor;
